<!-- 级联选择组件 -->
<template>
  <div class="cascader-module">
    <a-cascader
      :options="options"
      :loadData="loadData"
      :placeholder="placeholder"
      :value="targetValue"
      :disabled="disabled"
      :areaCode="areaCode"
      change-on-select
      @change="handleChange"
      @popupVisibleChange="popupVisibleChange"
      :getPopupContainer="getPopupContainer"
      :checkStrictly="false"
    />
  </div>
</template>

<script>
import API from "@/api/select"; // 请求接口

export default {
  name: "CascaderModule",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: Array,
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    // 菜单渲染父节点
    popupContainer: {
      type: String,
      required: false,
    },
    // 选择框默认文字
    placeholder: {
      type: String,
      required: false,
      default: "请选择",
    },
    areaCode: {
      type: String,
      required: false,
      default: "",
    },
    isShowDetail: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      options: [],
      LevelList: [],
      arr: [],
    };
  },
  computed: {
    // 当前选中的值
    targetValue: {
      get: function (val) {
        return this.value || "";
      },
      set: function (val) {
        // this.handleChange(val);
      },
    },
  },
  mounted() {
    this.getAreaList();
  },
  methods: {
    // 获取菜单渲染父节点
    getPopupContainer(trigger) {
      if (this.popupContainer == "body") {
        // 相对body定位
        return document.body;
      } else {
        // 相对父级节点定位
        return trigger.parentNode;
      }
    },

    // 获取省
    getAreaList() {
      API.getAreaList(
        {
          data: {
            params: {
              parentCode: this.areaCode ? this.areaCode : "",
            },
          },
        },
        (callback) => {
          let list = []; // 数据
          if (callback.status == "S" && callback.data) {
            if (Array.isArray(callback.data) && callback.data.length > 0) {
              list = callback.data;
            }
            this.options = list.map((item) => ({
              label: item.name,
              value: item.id,
              isLeaf: false,
            }));
          }
        }
      );
    },
    // change事件
    handleChange(id, option) {
      console.log('id', id)
      console.log('option~~~~112', option)
      this.$emit("change", id, option);
    },
    // 加载二三级
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];

      // this.levelIndex = selectedOptions.length + 1;
      targetOption.loading = true;
      // 获取市县
      API.getAreaList(
        {
          data: {
            params: {
              parentCode: targetOption.value || "",
            },
          },
        },
        (callback) => {
          if (callback.data.length > 0) {
            setTimeout(() => {
              targetOption.loading = false;
              targetOption.children = callback.data.map((item) => ({
                label: item.name,
                value: item.id,
                isLeaf: item.depth == 3 ? true : false,
              }));
              this.options = [...this.options];
            }, 1000);
          }
        }
      );
    },
    popupVisibleChange(value) {
      this.$emit("visibleChange", value);
    },
    // 加载下一集
    loadNext(targetOption) {
      let obj = {
        parentCode: targetOption,
      };

      API.getAreaList(
        {
          data: {
            params: {
              ...obj,
            },
          },
        },
        (callback) => {
          if (callback.data.length > 0) {
            setTimeout(() => {
              const list = callback.data.map((item) => {
                // dLevel == 3 时表示是叶子节点
                this.$set(item, "isLeaf", item.depth == 3 ? true : false);
                this.$set(item, "value", item.id);
                this.$set(item, "label", item.name);
                return item;
              });
              //初始化时，this.options包含全部第一层级的数据
              this.options.forEach((item) => {
                if (item.children) {
                  item.children.forEach((ite) => {
                    if (ite.value == targetOption) {
                      this.$set(ite, "children", list);
                    }
                  });
                }
                if (item.value == targetOption) {
                  //数据value值等于父id
                  this.$set(item, "children", list);
                }
              });
              this.options = [...this.options];
            });
          }
        }
      );
    },
  },
  watch: {
    isShowDetail: {
      handler(newVal) {
        if (newVal) {
          if (this.value && this.value.length > 0) {
            for (let i = 0; i < this.value.length - 1; i++) {
              this.loadNext(this.value[i]); //获取下一层级的数据
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    value(newVal) {
      this.targetValue = newVal;
    },
  },
};
</script>

<style scoped lang="less">
.cascader-module {
  width: 100%;
}
</style>
